import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  AfterContentChecked,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';

import * as AOS from 'aos';
import { Subject, Observable } from 'rxjs';
import { DashboardFacade } from '../abstraction/dashboard.facade';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'makaw-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent
  implements OnInit, AfterContentChecked, OnDestroy {
  @Output() balanceOutput = new EventEmitter<any>();
  public user;
  private destroyed$ = new Subject();
  public dataReady = false;
  public balance;
  public balanceLoaded = false;
  public balance$: Observable<number>;
  public score$: Observable<number>;
  public user$: Observable<any>;
  public score: number;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private readonly dashboardFacade: DashboardFacade
  ) {}

  ngOnInit() {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
    });
    this.dashboardFacade.loadData();

    this.user$ = this.dashboardFacade.getUser$();
    this.score$ = this.dashboardFacade.getScore$();
    this.balance$ = this.dashboardFacade.getBalance$();

    this.user$.pipe(takeUntil(this.destroyed$)).subscribe((user) => {
      this.user = user;
      this.dataReady = true;
    });
    this.score$.pipe(takeUntil(this.destroyed$)).subscribe((score) => {
      this.score = score;
    });
    this.balance$.pipe(takeUntil(this.destroyed$)).subscribe((balance) => {
      this.balance = balance;
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  setBalance(balance: number) {
    this.dashboardFacade.calculateScore(this.balance, balance);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
